// extracted by mini-css-extract-plugin
export default {"devider":"Devider_devider__C30p6"};